import React from "react";
import PropTypes from "prop-types";
import "./ArashTradeModal.css";

//------------------ ArashTradeModal Component ------------------
const ArashTradeModal = ({ open, onClose }) => {
  if (!open) return null; // ← Nothing to render

  // Dismiss if the overlay (but not the inner box) is clicked
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  //------------------------ JSX ------------------------
  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal">
        <button className="modal-close" onClick={onClose} aria-label="Close modal">
          &times;
        </button>

        <div className="logo-container">
          <img className="logo" src="/assets/arash-trade-logo.png" alt="arash-trade-logo" loading="lazy" />
        </div>
        <p className="modal-text">
        To explore the app, please install <strong>Expo&nbsp;Go</strong> on your device 
        </p>
        <p className="text2">Then scan the QR code below</p>
        <div className="qr-container">
          <img className="qr-code" src="/assets/qr-code.png" alt="QR-code " loading="lazy" />
        </div>
        <p className="github-link">
          App Demo:{" "}
          <a
            href="https://www.linkedin.com/feed/update/urn:li:activity:7342512200512606208/"
            target="_blank"
            rel="noopener noreferrer"
            className="github-anchor"
          >
            ArashTrade Preview
          </a>
        </p>
        <p className="github-link">
          GitHub frontend:{" "}
          <a
            href="https://github.com/arash8877/ArashTrade"
            target="_blank"
            rel="noopener noreferrer"
            className="github-anchor"
          >
            arash8877/ArashTrade
          </a>
        </p>
        <p className="github-link">
          GitHub backend:{" "}
          <a
            href="https://github.com/arash8877/ArashTrade-Backend"
            target="_blank"
            rel="noopener noreferrer"
            className="github-anchor"
          >
            arash8877/ArashTrade-Backend
          </a>
        </p>
      </div>
    </div>
  );
};

ArashTradeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ArashTradeModal;
